import React from "react";
import { DeviceFrameset } from "react-device-frameset";
import SurveyStyleTypes from "./surveyStyleTypes/surveyStyleTypes";
import "react-device-frameset/styles/marvel-devices.min.css";

// Simulator component that we are using to represent our theme setting
export const DeviceSimulator = (props) => {
  return (
    <DeviceFrameset color="white" device={props.deviceName}>
      <SurveyStyleTypes
        displayType={props.displayType}
        profileData={props.profileData}
      />
    </DeviceFrameset>
  );
};
